export const POLITIQUE_CONFIDENTIALITE = `
1. INTRODUCTION
La présente Politique de Confidentialité a pour but d'informer les utilisateurs du site https://mon-budget-app.com sur la manière dont leurs données personnelles sont collectées, utilisées et protégées par Mickael ROYER.

2. DONNÉES COLLECTÉES
Dans le cadre de l'utilisation de "Mon Budget App", nous collectons les données suivantes :

    Informations de compte : Nom, adresse e-mail, mot de passe (haché via l'algorithme bcrypt).

    Données financières saisies manuellement : Noms des comptes bancaires, libellés de transactions, montants, dettes et créances.

    Données techniques : Adresse IP (via nos hébergeurs Render/Netlify), logs de connexion.

Note : À aucun moment le site ne se connecte directement à vos comptes bancaires réels. Toutes les données financières sont déclaratives.

3. FINALITÉ DU TRAITEMENT
Vos données sont utilisées exclusivement pour :

    La création et la gestion de votre espace utilisateur.

    Le calcul automatique de vos soldes et de vos prévisions budgétaires.

    L'envoi d'e-mails techniques (réinitialisation de mot de passe, vérification de compte) via notre prestataire Mailjet.

    La gestion de votre abonnement (via Stripe pour les futurs plans payants).

4. CONSERVATION DES DONNÉES
Nous conservons vos données tant que votre compte est actif. En cas de suppression de compte, toutes vos données financières et personnelles sont définitivement effacées de notre base de données PostgreSQL dans un délai de 30 jours, sous réserve des obligations légales de conservation (notamment pour les factures d'abonnement).

5. PARTAGE DES DONNÉES
Vos données ne sont jamais vendues ou louées à des tiers. Elles sont uniquement partagées avec nos prestataires techniques nécessaires au fonctionnement du service :

    Hébergement : Render (Base de données et API) et Netlify (Interface).

    Envoi d'e-mails : Mailjet.

    Paiement : Stripe.

6. SÉCURITÉ
Nous mettons en œuvre des mesures de sécurité rigoureuses :

    Utilisation du protocole HTTPS pour tous les transferts de données.

    Chiffrement des mots de passe via bcrypt.

    Protection contre les attaques courantes (via le middleware Helmet et des limiteurs de requêtes côté backend).

7. VOS DROITS (RGPD)
Conformément au RGPD, vous disposez d'un droit d'accès, de rectification, de portabilité et de suppression de vos données. Vous pouvez également demander la limitation du traitement. Pour exercer ces droits, vous pouvez nous contacter à : support@mon-budget-app.com.
`;